import { useEffect, useRef } from "react";

type UseFocusWhenOptions = {
  enabled: boolean;
  delayMs?: number;
  selectText?: boolean;
};

export function useFocusWhen<T extends HTMLElement>({
  enabled,
  delayMs = 0,
  selectText = false,
}: UseFocusWhenOptions) {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      ref.current?.focus();
      if (selectText && ref.current instanceof HTMLInputElement) {
        ref.current.select();
      }
    }, delayMs);

    return () => window.clearTimeout(timeoutId);
  }, [delayMs, enabled, selectText]);

  return ref;
}
